export default __webpack_public_path__ + "static/media/Cadres_Alpha.f90952c6.jpg";